export const INTEGRATE_CAMPAIGN_MONITOR =
  'APP/STORES/PLATFORM_COMPONENT/EMAIL/CAMPAIGN_MONITOR/INTEGRATE'
export const INTEGRATE_CAMPAIGN_MONITOR_SUCCESS =
  'APP/STORES/PLATFORM_COMPONENT/EMAIL/CAMPAIGN_MONITOR/INTEGRATE_SUCCESS'
export const INTEGRATE_CAMPAIGN_MONITOR_ERROR =
  'APP/STORES/PLATFORM_COMPONENT/EMAIL/CAMPAIGN_MONITOR/INTEGRATE_ERROR'
